import React from 'react';
import { TranslationKey } from '../utils/i18n';
import { FormattedMessage as IntlFormattedMessage } from 'react-intl';

interface FormattedMessageProps extends React.ComponentProps<typeof IntlFormattedMessage> {
  id: TranslationKey;
}

const FormattedMessage = (props: FormattedMessageProps) => {
  return <IntlFormattedMessage {...props} />;
};

export default FormattedMessage;
